<template>
  <div class="asHeaderMain">
    <router-link :to="{ name: PAGE_NAME.HOME }">
      <div
        class="asHeaderMain_logo"
        :style="{ backgroundImage: `url(${logo.src})` }"
      ></div>
    </router-link>

    <slot name="breadcrumb" />

    <router-link :to="{ name: 'points' }" class="asHeaderMain_wrap">
      <div class="asHeaderMain_avatar">
        <img :src="user.avatar" alt="" class="asHeaderMain_photo">
      </div>
      <div class="asHeaderMain_user">
        <span class="asHeaderMain_name">{{ username }}</span>
        <ac-points-label class="asHeaderMain_points" :points="userScoreAmount"/>
<!--        <span class="asHeaderMain_city">{{ user.city }} </span>-->
      </div>
    </router-link>
    <slot name="menu">
      <div class="asHeaderMain_setting" @click.stop.self="toggleMenu">
        <div class="asHeaderMain_menu" v-if="menuOpen">
          <a
            v-if="user.isAdmin"
            class="asHeaderMain_item"
            :href="urlAdmin"
            data-analytics
            data-analytics-element-type="menu_user"
            :data-analytics-element-target="urlAdmin"
            data-analytics-element-id="dashboard"
            :data-analytics-element-name="$t('dashboard')"
          >
            <i class="asHeaderMain_icon -ext"></i>
            {{$t('dashboard')}}
          </a>

          <template
            v-for="(item, i) in menu"
          >
            <router-link
              :key="i"
              v-if="item.type === 'router-link'"
              :to="item.link"
              class="asHeaderMain_item"
              data-analytics
              data-analytics-element-type="menu_user"
              :data-analytics-element-target="item.to"
              :data-analytics-element-id="item.icon"
              :data-analytics-element-name="item.name"
            >
              <i class="asHeaderMain_icon" :class="`${item.icon}`"></i>
              {{item.name}}
            </router-link>

            <div
              :key="i"
              v-if="item.type === 'modal'"
              class="asHeaderMain_item"
            >
              <i class="asHeaderMain_icon" :class="`${item.icon}`"></i>
              <as-external-document
                :doc="{
                url: item.link,
                title: item.name
              }"
                :is-modal="true"
                :icon="false"
              />
            </div>
          </template>
        </div>
      </div>
    </slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'

import Token from '@web/common/token'
import { useStore } from '@web/store'

import AsExternalDocument from '@web/components/AsExternalDocument.vue'
import AcPointsLabel from '@web/components.v2/PointsLabel.vue'

import PAGE_NAME from '@web/consts/PAGE_NAME'
import Analytics from '@web/services/Analytics/Analytics'

export default defineComponent({
  components: {
    AcPointsLabel,
    AsExternalDocument
  },
  setup () {
    const store = useStore()

    const menuOpen = ref(false)
    const user = computed(() => store.getters['user/user'])
    const username = computed(() => store.getters['user/username'])
    const logo = computed(() => store.getters['assets/logo'])
    const menu = computed(() => store.getters['menu/setting'])
    const userScoreAmount = computed(() => store.getters['userScore/amount'])
    const urlAdmin = computed(() => `/admin/login?token=${Token.get()}`)

    function closeMenu () {
      menuOpen.value = false
      document.body.removeEventListener('click', closeMenu)
      Analytics.send({
        action: 'close_burger',
        project: 'platform'
      })
    }

    function openMenu () {
      menuOpen.value = true
      document.body.addEventListener('click', closeMenu)
      Analytics.send({
        action: 'open_burger',
        project: 'platform'
      })
    }

    function toggleMenu () {
      if (menuOpen.value) {
        closeMenu()
      } else {
        openMenu()
      }
    }

    return {
      menuOpen,
      user,
      username,
      logo,
      menu,
      userScoreAmount,
      urlAdmin,

      toggleMenu,
      PAGE_NAME
    }
  }
})
</script>

<style lang="scss">
  .asHeaderMain {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 1217px;
    max-width: 1217px;
    margin: 25px auto 25px;
    padding-left: 18px;
    height: 83px;

    &_logo {
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      width: 114px;
      height: 38px;
    }

    &_breadcrumb {
    }

    &_user {
      display: flex;
      flex-flow: column nowrap;
      align-items: flex-start;
      justify-content: flex-start;
    }

    &_wrap {
      display: flex;
      align-items: center;
      margin-left: auto;
      padding: 14px 15px;
      border-radius: 6px;

      cursor: pointer;
      text-decoration: none;

      &:hover {
        background-color: rgba(255, 255, 255, .24);
      }
    }

    &_avatar {
      display: flex;
      width: 60px;
      height: 60px;
      padding: 3px;
      margin-right: 16px;

      border-radius: 7px;
      background-color: #fff;
    }

    &_photo {
      display: block;
      width: 55px;
      height: 55px;

      margin: auto;
      border-radius: 6px;
      overflow: hidden;
      object-position: center;
      object-fit: cover;
    }

    &_name {
      display: block;
      max-width: 250px;

      color: #ffffff;
      font-size: 20px;
      font-weight: 400;
      line-height: 25px;
      white-space: pre;
      text-overflow: ellipsis;

      overflow: hidden;
    }

    &_city {
      display: block;
      max-width: 250px;

      color: rgba(255, 255, 255, 0.6);
      font-size: 16px;
      font-weight: 400;
      line-height: 21px;
      white-space: pre;
      text-overflow: ellipsis;

      overflow: hidden;
    }

    &_points {
      display: block;
      max-width: 250px;
      margin-top: 6px;
    }

    &_setting {
      position: relative;

      display: block;
      width: 22px;
      height: 23px;
      margin-left: 40px;

      background-image: url(~@web/assets/images/icon-setting-fff.svg);
      background-repeat: no-repeat;
      background-size: cover;

      cursor: pointer;
      flex: 0 0 auto;
    }

    &_menu {
      position: absolute;
      top: 55px;
      right: 0;
      z-index: 99;

      width: 288px;
      border-radius: 10px;
      background-color: white;
    }

    &_item {
      position: relative;

      display: flex;
      height: 63px;
      align-items: center;
      padding: 0 35px 0 72px;

      color: rgb(76, 82, 100);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      text-decoration: none;
      transition: all .3s;

      &:first-letter {
        text-transform: uppercase;
      }

      &:hover,
      &:active,
      &:focus {
        color: rgb(0, 0, 0);
      }

      &:last-of-type {
        border: none;
      }

      .asExternalDocument_link {
        margin-bottom: 0;
        color: #4c5264;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        text-decoration: none;
      }
    }

    &_icon {
      position: absolute;
      top: 50%;
      left: 35px;
      transform: translateY(-50%);
      background-repeat: no-repeat;

      &.-course {
        width: 24px;
        height: 24px;

        background-image: url(~@web/assets/images/menu/icon-menu-mycourses.svg);
      }

      &.-chat {
        width: 24px;
        height: 24px;

        background-image: url(~@web/assets/images/menu/icon-menu-messages.svg);
      }

      &.-homework {
        width: 24px;
        height: 24px;

        background-image: url(~@web/assets/images/menu/icon-menu-homeworks.svg);
      }

      &.-userEdit {
        width: 24px;
        height: 24px;

        background-image: url(~@web/assets/images/menu/icon-menu-profile-edit.svg);
      }

      &.-settings {
        width: 24px;
        height: 24px;

        background-image: url(~@web/assets/images/menu/icon-menu-settings.svg);
      }

      &.-points {
        width: 24px;
        height: 24px;

        background-image: url(~@web/assets/images/menu/icon-menu-points.svg);
      }

      &.-link {
        width: 24px;
        height: 24px;

        background-image: url(~@web/assets/images/menu/icon-menu-linksocial.svg);
      }

      &.-stat {
        width: 21px;
        height: 21px;

        background-image: url(~@web/assets/images/icon-stat.svg);
      }

      &.-subscribe {
        width: 23px;
        height: 21px;

        background-image: url(~@web/assets/images/icon-subscribe.svg);
      }

      &.-referral {
        width: 25px;
        height: 25px;

        background-image: url(~@web/assets/images/icon-referral.svg);
      }

      &.-instruction {
        width: 20px;
        height: 20px;
        background-size: contain;
        background-position: center;
        background-image: url(~@web/assets/images/icon-instruction.svg);
      }

      &.-support {
        width: 24px;
        height: 24px;

        background-image: url(~@web/assets/images/menu/icon-menu-support.svg);
      }

      &.-videoconsultations {
        width: 24px;
        height: 24px;

        background-image: url(~@web/assets/images/menu/icon-menu-videoconsultations.svg);
        background-size: contain;
      }

      &.-password {
        width: 18px;
        height: 21px;

        background-image: url(~@web/assets/images/icon-password.svg);
      }

      &.-payment {
        width: 20px;
        height: 15px;

        background-image: url(~@web/assets/images/icon-payment.svg);
      }

      &.-exit {
        width: 24px;
        height: 24px;

        background-image: url(~@web/assets/images/menu/icon-menu-logout.svg);
      }

      &.-ext {
        width: 20px;
        height: 20px;

        background-image: url(~@web/assets/images/icon-ext.svg);
      }

      &.-manual {
        width: 20px;
        height: 20px;

        background-image: url(~@web/assets/images/icon-manual-blue.svg);
        background-size: cover;
      }
    }
  }
</style>
